import {
  GET_ALL_SHOPS,
  GET_ALL_SHOPS_RESPONSE_SUCCESS,
  CREATE_SHOP,
  UPDATE_SHOP,
  DELETE_SHOP,
} from "./actionTypes"

export const getAllShops = () => {
  return {
    type: GET_ALL_SHOPS,
  }
}
export const getAllShopsResponseSuccess = payload => ({
  type: GET_ALL_SHOPS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createShop = (payload, history) => {
  return {
    type: CREATE_SHOP,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateShop = (payload, history, id) => {
  return {
    type: UPDATE_SHOP,
    payload: payload,
    history,
    id,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteShop = payload => ({
  type: DELETE_SHOP,
  payload: payload,
})
